<template>
  <div class="simple-infographic-card">
    <div class="simple-infographic-card-label">
      {{ label }}
    </div>

    <div class="simple-infographic-card-content">
      <div
        class="simple-infographic-card-icon"
        :style="{
          backgroundColor: iconBackgroundColor
        }"
      >
        <svg-loader
          :src="iconSrc"
          :style="{
            color: highlightColor
          }"
        />
      </div>

      <div class="simple-infographic-card-values">
        <div
          class="simple-infographic-card-value"
          :style="{
            color: highlightColor
          }"
        >
          {{ value }}
        </div>

        <div
          v-if="secondaryValue"
          class="simple-infographic-card-secondary-value"
        >
          {{ secondaryValue }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hexToRGBA } from '@/utils/color';

export default {
  name: 'SimpleInfographicCard',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    secondaryValue: {
      type: String,
      default: ''
    },
    iconSrc: {
      type: String
    },
    highlightColor: {
      type: String,
      default: '#000000'
    }
  },
  computed: {
    iconBackgroundColor() {
      return hexToRGBA(this.highlightColor, 0.1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/../static/stylesheets/variables';

.simple-infographic-card {
  border-radius: 0.375rem;
  padding: 1rem;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-family: "Exo 2";

  &-label {
    flex: 1;
    font-weight: 700;
    font-size: 1.125rem;
    color: #818181;
  }

  &-content {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  &-icon {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    .md-icon {
      width: 1.125rem;
      min-width: auto;
      height: 1.125rem;
      min-height: auto;
    }
  }

  &-value {
    font-weight: 700;
    font-size: 1.5rem;
  }

  &-values {
    min-width: 0;
    display: flex;
    gap: 0.375rem;
    align-items: baseline;
    flex-wrap: wrap;
  }

  &-secondary-value {
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1;
    color: #818181;
    white-space: nowrap;
  }
}
</style>
